var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.668C17.5228 22.668 22 18.1908 22 12.668C22 7.14512 17.5228 2.66797 12 2.66797C6.47715 2.66797 2 7.14512 2 12.668C2 18.1908 6.47715 22.668 12 22.668Z",
    stroke: "#345C72",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.66797H10C9.46957 8.66797 8.96086 8.87868 8.58579 9.25376C8.21071 9.62883 8 10.1375 8 10.668C8 11.1984 8.21071 11.7071 8.58579 12.0822C8.96086 12.4573 9.46957 12.668 10 12.668H14C14.5304 12.668 15.0391 12.8787 15.4142 13.2538C15.7893 13.6288 16 14.1375 16 14.668C16 15.1984 15.7893 15.7071 15.4142 16.0822C15.0391 16.4573 14.5304 16.668 14 16.668H8",
    stroke: "#345C72",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.668V6.66797",
    stroke: "#345C72",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.9dd6d7377b5063c9572a80697b0d9cc8.svg";
export { ForwardRef as ReactComponent };